import { CheckCircle, XCircle, X } from "lucide-react";
import { useEffect, useState } from "react";

interface ToastProps {
  isVisible: boolean;
  title: string;
  message: string;
  type: "success" | "failure";
}

export default function Toast({ isVisible, title, message, type }: ToastProps) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    setVisible(isVisible);
  }, [isVisible]);

  if (!visible) return null;

  const isSuccess = type === "success";

  return (
    <div className="fixed top-4 right-4 z-50">
      <div className="flex items-start gap-4 rounded-lg bg-white shadow-lg px-6 py-4 border border-gray-200 w-full max-w-sm">
        {isSuccess ? (
          <CheckCircle className="text-green-500 mt-1" />
        ) : (
          <XCircle className="text-red-500 mt-1" />
        )}
        <div className="flex-1">
          <p
            className={`font-semibold ${isSuccess ? "text-green-700" : "text-red-700"}`}
          >
            {title}
          </p>
          <p className="text-sm text-gray-500">{message}</p>
        </div>
        <button
          onClick={() => setVisible(false)}
          className="text-gray-400 hover:text-gray-600"
        >
          <X className="w-5 h-5" />
        </button>
      </div>
    </div>
  );
}
